import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppParametersService, BaseAppParameters } from '@immosky/types';

export interface NewseltterSignup {
  email: string;
  first_name: string;
  last_name: string;
}

@Injectable({
  providedIn: 'root',
})
export class NewsletterSignupService {
  constructor(
    private httpClient: HttpClient,
    private appParametersService: AppParametersService<BaseAppParameters>
  ) {}

  signUp(data: NewseltterSignup) {
    const form_data = new FormData();
    form_data.append('email', data.email);
    form_data.append('first_name', data.first_name);
    form_data.append('last_name', data.last_name);
    const appConfig = this.appParametersService.get();
    if (appConfig.searchSubscriptionNewsletterSignupUrl) {
      this.httpClient
        .post(appConfig.searchSubscriptionNewsletterSignupUrl, form_data)
        .subscribe((resp) => {
          // Is not defined what should happen if a newsletter signup was not successfull.
        });
    }
  }
}
